import { Component, Input } from '@angular/core';
import { TTranslationKey } from 'src/app/project/features/translate/types';
import { RELATED_POINT_TYPE_LABEL_KEY } from '../../../../../../../components/related-points/related-point-type-labels.consts';
import { EIconPath } from '../../../../../../../shared/enums/icons.enum';

@Component({
  selector: 'pp-dashlet-activity-relation',
  templateUrl: './dashlet-activity-relation.component.html',
  styleUrls: ['../../dashlet-activity.component.scss'],
  standalone: false,
})
export class DashletActivityRelationComponent {
  @Input() ppRelatedPointTitle: string;
  @Input() ppRelationshipType: string | undefined;
  @Input() ppAction: string | undefined;

  EIconPath = EIconPath;
  relatedPointTypeLabelKey: Record<string, TTranslationKey> = RELATED_POINT_TYPE_LABEL_KEY;
}
